import { Decimal } from 'decimal.js';
import { HUNDRED } from '../constants/constants';
import { isNil } from 'es-toolkit';

/** Expected VAT amount for a net amount and rate. Null when either input is missing. */
export function computeExpectedVat(
  netAmount: Decimal | null | undefined,
  vatRate: Decimal | null | undefined
): Decimal | null {
  if (isNil(netAmount) || isNil(vatRate)) return null;
  return netAmount.times(vatRate).dividedBy(HUNDRED);
}

/** Expected net amount back-derived from a VAT amount and rate. Null when either input is missing. */
export function computeExpectedNet(
  vatAmount: Decimal | null | undefined,
  vatRate: Decimal | null | undefined
): Decimal | null {
  if (isNil(vatAmount) || isNil(vatRate) || vatRate.isZero()) return null;
  return vatAmount.times(HUNDRED).dividedBy(vatRate);
}
